import React, { useEffect, useState } from 'react';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import { IoIosRemoveCircleOutline } from 'react-icons/io';

import InputLabel from '../Inputs/InputLabel';
import { TextInputV2 } from './TextInputV2';

interface SelectCreatorV2Props {
  name: string;
  onChange: (
    value: { value: string | undefined; label: string | undefined }[]
  ) => void;
  label?: string;
}

export const SelectCreatorV2 = ({
  name,
  label,
  onChange,
}: SelectCreatorV2Props) => {
  const [options, setOptions] = useState<
    { id: number; value: string | undefined; label: string | undefined }[]
  >([]);
  const [isAddButtonActive, setIsAddButtonActive] = useState(true);

  useEffect(() => {
    setIsAddButtonActive(true);

    options.some((o) => {
      if (!o.value || !o.label) {
        setIsAddButtonActive(false);

        return true;
      }

      return false;
    });

    onChange(options);
  }, [options]);

  const renderOptions = () => {
    return options.map((o) => {
      return (
        <div
          key={o.id}
          className="w-full flex justify-center items-center space-s-4"
        >
          <TextInputV2
            label="Value"
            placeholder="Value"
            value={o.value}
            onChange={(value) => {
              setOptions(
                options.map((oo) => {
                  if (oo.id === o.id) {
                    return {
                      ...oo,
                      value,
                    };
                  } else {
                    return oo;
                  }
                })
              );
            }}
          />
          <TextInputV2
            label="Label"
            placeholder="Label"
            value={o.label}
            onChange={(value) => {
              setOptions(
                options.map((oo) => {
                  if (oo.id === o.id) {
                    return {
                      ...oo,
                      label: value,
                    };
                  } else {
                    return oo;
                  }
                })
              );
            }}
          />
          <div
            className="mr-2 text-red-500 self-end cursor-pointer"
            onClick={() => {
              setOptions(options.filter((oo) => oo.id !== o.id));
            }}
          >
            <IoIosRemoveCircleOutline />
          </div>
        </div>
      );
    });
  };

  return (
    <div>
      <div>
        <InputLabel name={name} text={label} />
      </div>
      <div
        className={`text-[19px] ${
          isAddButtonActive
            ? 'text-primary cursor-pointer'
            : 'text-warmGray-300'
        }`}
        onClick={() => {
          if (isAddButtonActive) {
            setOptions([
              { id: Date.now(), value: undefined, label: undefined },
              ...options,
            ]);
          }
        }}
      >
        <AiOutlinePlusCircle />
      </div>
      <div className="mt-1">{renderOptions()}</div>
    </div>
  );
};
